import { NOTIFICATIONS_TYPES } from 'infrastructure/notification/constants';
import { NotificationItemProps } from 'infrastructure/notification/types';
import { InterruptionNotificationResponse } from '../types';
import InterruptionNotification from './InterruptionNotification';
import { useAvailabilityCurrentUser } from '../../availabilityUser/AvailabilityCurrentUserProvider';

const useInterruptionNotifications = (): NotificationItemProps<InterruptionNotificationResponse>[] => {
  const { isAvailabilityEnabled } = useAvailabilityCurrentUser();

  if (!isAvailabilityEnabled) {
    return [];
  }

  return [
    {
      type: NOTIFICATIONS_TYPES.INTERRUPTION,
      isVisible: (response: InterruptionNotificationResponse) => {
        return (response?.count || 0) > 0;
      },
      getCount: (response: InterruptionNotificationResponse) => response?.count ?? 0,
      component: (response: InterruptionNotificationResponse) => <InterruptionNotification response={response} />,
    },
  ];
};

export default useInterruptionNotifications;
